export default "__VITE_ASSET__cd371400__"